/* hc-assemble.js, theme v1.2.0: loaded by sections\hc-assemble-hero.liquid. Ported from
   theme\_options\interactive\B-assemble\asm.js (v3); one change: the landing order comes from data-order. */
/* Scroll-assemble hero for Harmony Cookies (hero library 07, adapted), v3: the cookies are the end state.
   The hero pins for 80svh of scroll. The five petals travel in from apart, one after another, and settle into the
   flower; each flavour's cookie, with its name, rides in on its own petal and peels off along that petal's line to
   its place in the ring (asm.css). The apart distance is MEASURED per petal: the largest shift that keeps that
   petal's own occupied cells (petals.json, read off its pixels) inside the stage, capped at 36% of the flower.
   In the last tenth the clean lone petals hand over to the five parts that add up to the logo's own pixels.
   Reduced motion, no JS, or a viewport too short to hold the pinned hero: the same end state, still. */
(function () {
  'use strict';
  var root = document.querySelector('[data-asm]'); if (!root) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { root.dataset.mode = 'still-reduced'; return; }
  var data = JSON.parse(root.getAttribute('data-petals'));
  var stick = root.querySelector('[data-asm-stick]'), stage = root.querySelector('[data-asm-stage]'), flower = root.querySelector('[data-asm-flower]');
  var run = root.querySelector('[data-asm-run]'), cleanSet = root.querySelector('[data-asm-clean]'), partSet = root.querySelector('[data-asm-part]');
  var head = document.querySelector('.hc-head-wrap');
  // landing order: the section's petal blocks, in the editor's order (data-order); the mirror page carries it in data-petals
  var keys = (root.getAttribute('data-order') || '').split(',').filter(Boolean); if (!keys.length) keys = data.order;
  var clean = {}, part = {}, labs = {}, cks = {}, pills = {};
  keys.forEach(function (k) {
    clean[k] = cleanSet.querySelector('img[data-k="' + k + '"]'); part[k] = partSet.querySelector('img[data-k="' + k + '"]');
    labs[k] = root.querySelector('.asm-lab[data-k="' + k + '"]'); cks[k] = labs[k].querySelector('.asm-ck'); pills[k] = labs[k].querySelector('.asm-pill');
  });
  var clamp = function (x) { return x < 0 ? 0 : x > 1 ? 1 : x; };
  var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
  var geo = null, raf = 0, last = -1, S = 0.6;
  function measure() {
    var hh = head ? head.getBoundingClientRect().height : 0;
    root.style.setProperty('--stick-top', Math.round(hh) + 'px');
    keys.forEach(function (k) { labs[k].style.transform = ''; cks[k].style.transform = ''; pills[k].style.transform = ''; });
    root.classList.add('is-anim');
    if (stick.getBoundingClientRect().height > window.innerHeight - hh) { root.classList.remove('is-anim'); root.dataset.mode = 'still-short'; geo = null; return; }
    root.dataset.mode = 'anim';
    var fr = flower.getBoundingClientRect(), sr = stage.getBoundingClientRect();
    var fw = fr.width, fh = fr.height, cx = data.c[0] * fw, cy = data.c[1] * fh;
    var L = sr.left - fr.left + 4, R = sr.right - fr.left - 4, T = sr.top - fr.top + 2, B = sr.bottom - fr.top - 2;
    var CAP = fw * 0.36, Dk = {}, dirs = {}, unit = {};
    keys.forEach(function (k) {
      var p = data.p[k], dx = p.c[0] * fw - cx, dy = p.c[1] * fh - cy, n = Math.hypot(dx, dy) || 1; dx /= n; dy /= n; dirs[k] = [dx, dy];
      var cw = fw / 32, chh = fh / 32, cells = [];
      p.g.forEach(function (row, gy) { for (var gx = 0; gx < 32; gx++) if (row.charAt(gx) === '1') cells.push([gx * cw, gy * chh]); });
      var D = 0;
      for (var t = Math.floor(CAP); t >= 0; t -= 2) {
        var ox = dx * t, oy = dy * t, hit = false;
        for (var c = 0; c < cells.length && !hit; c++) { var x0 = cells[c][0] + ox, y0 = cells[c][1] + oy; if (x0 < L || x0 + cw > R || y0 < T || y0 + chh > B) hit = true; }
        if (!hit) { D = t; break; }
      }
      Dk[k] = D;
      // the cookie unit: from the middle of its apart petal (start, at scale S) to its place in the ring (end)
      var lr = labs[k].getBoundingClientRect(), kr = cks[k].getBoundingClientRect();
      var ex = kr.left + kr.width / 2, ey = kr.top + kr.height / 2;
      var sx = fr.left + p.c[0] * fw + dx * D, sy = fr.top + p.c[1] * fh + dy * D;
      unit[k] = [sx - ex, sy - ey, getComputedStyle(labs[k]).transform]; // the CSS ring placement, kept first in the list
    });
    geo = { D: Dk, dirs: dirs, unit: unit };
    root.dataset.apart = JSON.stringify(keys.map(function (k) { return +(Dk[k] / fw).toFixed(3); }));
    last = -1; tick();
  }
  function tick() {
    raf = 0; if (!geo) return;
    var r = root.getBoundingClientRect(), hh = parseFloat(root.style.getPropertyValue('--stick-top')) || 0;
    var span = run.getBoundingClientRect().height, p = span > 0 ? clamp((hh - r.top) / span) : 1;
    if (p === last) return; last = p;
    keys.forEach(function (k, i) {
      var e = ease(clamp((p - i * 0.1) / 0.5)), u = 1 - e, d = geo.dirs[k], D = geo.D[k];
      var tf = e >= 1 ? 'none' : 'translate(' + (d[0] * D * u).toFixed(2) + 'px,' + (d[1] * D * u).toFixed(2) + 'px) rotate(' + (d[0] * 16 * u).toFixed(2) + 'deg) scale(' + (0.9 + 0.1 * e).toFixed(4) + ')';
      clean[k].style.transform = tf; part[k].style.transform = tf;
      clean[k].style.willChange = part[k].style.willChange = e >= 1 ? 'auto' : 'transform'; // settled pieces raster like the still logo
      // the unit: its CSS ring placement first, then the ride (a translate along the petal's line)
      var m = geo.unit[k];
      labs[k].style.transform = e >= 1 ? '' : (m[2] === 'none' ? '' : m[2] + ' ') + 'translate(' + (m[0] * u).toFixed(2) + 'px,' + (m[1] * u).toFixed(2) + 'px)';
      // only the cookie grows; its label stays full size (13px and up) the whole way, so it is always legible
      var sc = S + (1 - S) * e;
      cks[k].style.transform = e >= 1 ? '' : 'scale(' + sc.toFixed(4) + ')';
      // the label hugs the smaller cookie: moved toward its centre by the space the scale frees
      pills[k].style.transform = e >= 1 ? '' : 'translateY(' + ((labs[k].hasAttribute('data-up') ? 1 : -1) * (1 - sc) * cks[k].offsetHeight / 2).toFixed(2) + 'px)';
      labs[k].classList.toggle('is-in', e >= 0.999);
    });
    var s = clamp((p - 0.9) / 0.1);
    cleanSet.style.opacity = (1 - s).toFixed(3); partSet.style.opacity = s.toFixed(3);
    root.dataset.p = p.toFixed(3);
  }
  addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
  var rt = 0; addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 120); });
  measure();
  // fonts and late images change the label sizes, so the units are measured again once they are in
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  addEventListener('load', measure);
  window.__asm = function () { return { mode: root.dataset.mode, p: +root.dataset.p, apart: JSON.parse(root.dataset.apart || '[]'), lit: keys.filter(function (k) { return labs[k].classList.contains('is-in'); }).length }; };
})();
